<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span> vip配置</span>
          <!--          <el-button-->
          <!--            v-permisaction="['config:vipCfg:add']"-->
          <!--            style="margin-top: 10px;margin-left: 10px;"-->
          <!--            type="primary"-->
          <!--            icon="el-icon-plus"-->
          <!--            size="mini"-->
          <!--            @click="edit(0)"-->
          <!--          >新增</el-button>-->
          <el-row>
            <el-button type="primary" size="mini" @click="add">+</el-button>
            <el-button type="success" size="mini" @click="onSubmit">保存</el-button>
            <ClearCacheApply />
            <sync-data />
          </el-row>

        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="lv"
            label="vip等级"
            align="center"
            width="100"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.lv" placeholder="vip等级" />
            </template>
          </el-table-column>
          <el-table-column
            prop="integration"
            label="vip积分"
            align="center"
            width="120"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.integration" placeholder="vip积分" />
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="dayVipPoint"-->
          <!--            label="每日赠送积分"-->
          <!--            align="center"-->
          <!--            width="120"-->
          <!--          >-->
          <!--            <template scope="scope">-->
          <!--              <el-input v-model.number="scope.row.dayVipPoint" placeholder="每日赠送积分" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="taskRewardBet"-->
          <!--            label="任务奖励倍率(%)"-->
          <!--            align="center"-->
          <!--          >-->
          <!--            <template scope="scope">-->
          <!--              <el-input v-model.number="scope.row.taskRewardBet" placeholder="任务奖励倍率" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="spinsRestore"-->
          <!--            label="体力恢复增量"-->
          <!--            align="center"-->
          <!--          >-->
          <!--            <template scope="scope">-->
          <!--              <el-input v-model.number="scope.row.spinsRestore" placeholder="体力恢复增量" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="avatarBox"
            label="头像框"
            align="center"
            :formatter="avatarFormatter"
          >
            <template scope="scope">
              <el-select v-model="scope.row.avatarBox" placeholder="请选择">
                <el-option
                  v-for="item in avatarBoxArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="attackCoinsPro"
            label="打成功金币增加(%)"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.attackCoinsPro" placeholder="打成功金币增加(%)" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="stealCoinsPro"
            label="偷钱金币增加(%)"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.stealCoinsPro" placeholder="偷钱金币增加(%)" />
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            align="center"-->
          <!--            prop="miningGame"-->
          <!--            label="旷工时间增加(s)"-->
          <!--          >-->
          <!--            <template scope="scope">-->
          <!--              <el-input v-model.number="scope.row.miningGame" placeholder="旷工时间增加" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="oneClick"
            label="一键建造"
            align="center"
          >
            <template scope="scope">
              <el-select v-model="scope.row.oneClick" placeholder="请选择">
                <el-option
                  v-for="item in buildType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="oneClick"
            label="一键挖矿"
            align="center"
          >
            <template scope="scope">
              <el-select v-model="scope.row.oneDig" placeholder="请选择">
                <el-option
                  v-for="item in buildType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="beastId"
            label="野兽"
            align="center"
          >
            <template scope="scope">
              <el-select v-model="scope.row.beastId" placeholder="请选择">
                <el-option
                  v-for="item in animal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="diceId"
            label="骰子"
            align="center"
          >
            <template scope="scope">
              <el-select v-model="scope.row.diceId" placeholder="请选择">
                <el-option
                  v-for="item in dice"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="shield"
            label="盾"
            align="center"
          >
            <template scope="scope">
              <el-select v-model="scope.row.shieldId" placeholder="请选择">
                <el-option
                  v-for="item in shield"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            align="center"-->
          <!--            prop="mock"-->
          <!--            label="嘲讽图"-->
          <!--            :formatter="mockFormatter"-->
          <!--          >-->
          <!--            <template scope="scope">-->
          <!--              <el-select v-model="scope.row.mock" placeholder="请选择">-->
          <!--                <el-option-->
          <!--                  v-for="item in mockArr"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            align="center"
            prop="shieldGroove"
            label="盾牌槽增量"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.shieldGroove" placeholder="盾牌槽增量" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="prize"
            label="每日奖励"
          >
            <template scope="scope">
              <Reward v-model="scope.row.prize" :limit-type="limitType" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <!--              <el-button v-permisaction="['config:vipCfg:edit']" type="primary" size="small" @click="edit(scope.row.lv)">编辑</el-button>-->
              <el-button v-permisaction="['config:vipCfg:del']" type="danger" size="small" @click="del(scope.row.lv)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getVipCfgList, delVipCfgList, updateVipCfg } from '@/api/config/vip-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getCacheConfig } from '@/utils'
import Reward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'VipCfg',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      limitType: [14, 15],
      defaultFrom: {
        'lv': 0,
        'integration': 0,
        'signInBet': 0,
        'taskRewardBet': 0,
        'spinsRestore': 0,
        'avatarBox': 0,
        'shieldGroove': 0,
        'turnTable': {},
        'shopAppend': 0,
        'weekRewardSpins': 0,
        'weekRewardShield': 0,
        'weekRewardChest': {},
        'weekRewardBless': {},
        'weekRewardLuckydraw': {},
        'dayVipPoint': 0,
        'attackCoinsPro': 0,
        'stealCoinsPro': 0,
        'attackCss': 0,
        'miningGame': 0,
        'mock': 0,
        'oneClick': 0,
        'richkingStyle': 0,
        'beastId': 0,
        'diceId': 0,
        'shieldId': 0,
        oneDig: 0
      },
      tableData: [],
      buildType: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
      avatarBoxArr: [
        { label: '初级头像框', value: 1 },
        { label: '中级头像框', value: 2 },
        { label: '高级头像框', value: 3 },
        { label: '至尊头像框', value: 4 },
        { label: 'XX头像框', value: 5 }
      ],
      mockArr: [
        { label: '无', value: 0 },
        { label: '嘲讽图<1>', value: 1 },
        { label: '嘲讽图<2>', value: 2 },
        { label: '嘲讽图<3>', value: 3 },
        { label: '嘲讽图<4>', value: 4 },
        { label: '嘲讽图<5>', value: 5 }
      ],
      animal: [],
      shield: [],
      dice: []
    }
  },
  created() {
    this.initProps()
    this.getTables()
  },
  methods: {
    initProps() {
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { this.setConfig(this.animal, res.data) })
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { this.setConfig(this.shield, res.data) })
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { this.setConfig(this.dice, res.data) })
    },
    setConfig(conf, data) {
      conf.push({ label: '无', value: 0 })
      for (const i in data) {
        conf.push({ label: data[i].lang_key, value: parseInt(data[i].id) })
      }
    },
    getTables() {
      getVipCfgList().then(res => {
        if (res.code === 200) {
          this.tableData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.tableData.push(JSON.parse(JSON.stringify(this.defaultFrom)))
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVipCfgList({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    avatarFormatter(row, column) {
      let avatar = ''
      for (const i in this.avatarBoxArr) {
        const _avatar = this.avatarBoxArr[i]
        if (_avatar.value === row.avatarBox) {
          avatar = _avatar.label
        }
      }
      return avatar
    },
    mockFormatter(row, column) {
      let avatar = ''
      for (const i in this.mockArr) {
        const _avatar = this.mockArr[i]
        if (_avatar.value === row.mock) {
          avatar = _avatar.label
        }
      }
      return avatar
    },
    onSubmit() {
      const data = JSON.stringify(this.tableData)
      console.log(data)
      updateVipCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
